import { fetchAll } from '@/api/depart';
import { toTree } from '@/utils/tree';
import types from '../types';

const state = {
  departs: [],
  departTree: []
};

const mutations = {
  [types.SET_DEPARTS](state, departs) {
    state.departs = departs;
    state.departTree = toTree(departs);
  }
};

const actions = {
  fetchDeparts({ commit }) {
    this.tableLoading = true;
    return fetchAll()
      .then(res => {
        const departs = res.data.data || [];
        commit(types.SET_DEPARTS, departs);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/depart.js